export const firstLetterCapitalize = (text: string) => `${text.substring(0, 1).toLocaleUpperCase()}${text.slice(1)}`

/**
 * Truncates to maxLength at the last whole word, appending "..." if anything was cut.
 * Used for deriving a meta description excerpt from body copy when no dedicated field is set.
 */
export const truncateAtWordBoundary = (text: string, maxLength: number) => {
  const trimmed = text.trim()
  if (trimmed.length <= maxLength) return trimmed
  return `${trimmed.slice(0, maxLength).replace(/\s+\S*$/, '')}...`
}
/**
 * Decamelizes a string with/without a custom separator (underscore by default).
 *
 * @param str String in camelcase
 * @param separator Separator for the new decamelized string.
 */
export const decamelize = (str: string, separator: string) => {
  separator = typeof separator === 'undefined' ? '_' : separator

  return str
    .replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
    .toLowerCase()
}
